import React from "react";
import CustomIcon from "../../../components/CustomIcon";
import {ReactComponent as LogoSvg} from '../../../assets/img/svgs/logo.svg';

const UIHeader = () => {
  return (
    <div className="w-full flex bg-white justify-between items-center px-4 py-3 rounded-b-[--var(--border-radius)] shadow">
      <div className="flex items-center grow">
        <CustomIcon icon="menu" className="align-text-bottom text-dark" size="xl"/>
        <div className="grow flex justify-center">
          <LogoSvg width={90}/>
        </div>
      </div>
    </div>
  );
};

export default UIHeader;